import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class BeneficiaryForm extends DomainObject {
  name;
  url;
  instructions;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      url: observable,
      instructions: observable
    });

    this.merge(other);
  }
}

export default BeneficiaryForm;
